export default __webpack_public_path__ + "static/media/soil.d35c1e49.png";